import './masthead.css';
export default {
  "masthead": "pf-v6-c-masthead",
  "mastheadBrand": "pf-v6-c-masthead__brand",
  "mastheadContent": "pf-v6-c-masthead__content",
  "mastheadExpandableContent": "pf-v6-c-masthead__expandable-content",
  "mastheadLogo": "pf-v6-c-masthead__logo",
  "mastheadMain": "pf-v6-c-masthead__main",
  "mastheadToggle": "pf-v6-c-masthead__toggle",
  "modifiers": {
    "resizeObserver": "pf-m-resize-observer",
    "displayStack": "pf-m-display-stack",
    "displayInline": "pf-m-display-inline",
    "insetNone": "pf-m-inset-none",
    "insetSm": "pf-m-inset-sm",
    "insetMd": "pf-m-inset-md",
    "insetLg": "pf-m-inset-lg",
    "insetXl": "pf-m-inset-xl",
    "inset_2xl": "pf-m-inset-2xl",
    "displayStackOnSm": "pf-m-display-stack-on-sm",
    "displayInlineOnSm": "pf-m-display-inline-on-sm",
    "displayStackOnMd": "pf-m-display-stack-on-md",
    "displayInlineOnMd": "pf-m-display-inline-on-md",
    "displayStackOnLg": "pf-m-display-stack-on-lg",
    "displayInlineOnLg": "pf-m-display-inline-on-lg",
    "displayStackOnXl": "pf-m-display-stack-on-xl",
    "displayInlineOnXl": "pf-m-display-inline-on-xl",
    "displayStackOn_2xl": "pf-m-display-stack-on-2xl",
    "displayInlineOn_2xl": "pf-m-display-inline-on-2xl"
  },
  "toolbar": "pf-v6-c-toolbar",
  "toolbarContentSection": "pf-v6-c-toolbar__content-section",
  "toolbarExpandableContent": "pf-v6-c-toolbar__expandable-content"
};